import casusBackend from '@lexian/api/casus-api';
import {MasterData} from '_/state/masterdata';
import {
  fromInternalCostCenterToId,
  isInternalCostCenterId,
  toInternalCostCenterDisplayText,
} from '_/utilities/costCenter';

import {WorkLogActivity} from '../types';

export const createCostCenterWithDisplayName = async (
  costCenterId: string,
  masterdata: MasterData
): Promise<WorkLogActivity> => {
  const costCenterIsCasus = !isInternalCostCenterId(costCenterId);

  if (costCenterIsCasus) {
    let displayName = '';
    await casusBackend.getCasus({
      parameters: {casusId: costCenterId},
      onSuccess: ({body}) => {
        displayName = body.casus.displayNameWithClient;
      },
    });
    return {
      casusId: costCenterId,
      displayName,
    };
  } else {
    const internalId = fromInternalCostCenterToId(costCenterId);
    const {name: internalName} = masterdata.internalHoursCategories.find(
      (item) => item.id === internalId
    )!;
    return {
      internalHoursCategoryId: internalId,
      displayName: toInternalCostCenterDisplayText(internalName),
    };
  }
};
